import Data from './data'

export default {
    list: () => [200, Data.templates],
    download: () => [200, Data.template],
}
